function capitalize (str) {
  return (str && typeof str === 'string') ? (str?.charAt(0)?.toUpperCase() + str.slice(1)) : ''
}
function lowercase (str) {
  return (str && typeof str === 'string') ? str.toLowerCase() : ''
}

function removeSpaces (str) {
  return str.replace(/\s/g, '')
}

// Add str to targetStr by comma separating them
function commaSeparate (targetStr, str) {
  if (targetStr) {
    targetStr = targetStr + ', ' + str
  } else {
    targetStr = str
  }

  return targetStr
}

const replaceTerms = (text, terms) => {
  try {
    if (terms.serviceTerm && !! terms.servicePlural) {
      terms.servicePlural = terms.serviceTerm
    }

    let keys = ['serviceUser', 'serviceUserPlural', 'service', 'servicePlural']
    for (let thisKey of keys) {
      if (terms[thisKey]) {
        text = text.split(`{${thisKey}}`).join(terms[thisKey].trim()?.toLowerCase())
      }
    }
  } catch (err) {
    console.error('Error replacing terms in text')
  }

  return text
};

export { capitalize, removeSpaces, commaSeparate, lowercase, replaceTerms }
